"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IntegrationTab = exports.InstallationTab = void 0;

var _preact = require("preact");

var _Message = require("../../../ui-components/Message");

var _AccordionPanel = _interopRequireDefault(require("../../../panel/AccordionPanel"));

var _InputGroup = _interopRequireDefault(require("@insided/shared/uikit/InputGroup"));

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _StatelessPanel = _interopRequireDefault(require("../../../panel/StatelessPanel"));

var _ZapTemplateCard = require("./ZapTemplateCard");

var _assets = _interopRequireDefault(require("@insided/deprecated-preact-components/assets"));

var _IntegrationPanelItems = require("../integration-panel/IntegrationPanelItems");

var _constants = require("@insided/shared/constants");

var IntegrationTab = function IntegrationTab(_ref) {
  var isInstalled = _ref.isInstalled;

  // eslint-disable-next-line @typescript-eslint/no-var-requires
  var templates = require("./".concat(_constants.INTEGRATION_TAB_JSON_PATH));

  return (0, _preact.h)("div", {
    className: "integration__tab zapier_templates"
  }, !isInstalled && (0, _preact.h)(_Message.Message, {
    text: "Please install the app first to configure the integrations.",
    fullWidth: true
  }), templates.map(function (template) {
    return (0, _preact.h)(_StatelessPanel.default, {
      key: template.title,
      title: (0, _preact.h)(_IntegrationPanelItems.IntegrationPanelHeaderWithImages, {
        title: template.title,
        imageFromName: _constants.PLATFORM_INTEGRATION_LOGO_S_FILENAME,
        imageToName: template.icon,
        customClass: "zap-link",
        meta: (0, _preact.h)(_Button.default, {
          size: "medium",
          title: "Use this Zap",
          onClick: function onClick() {
            (0, _ZapTemplateCard.zapTemplateClicked)(template.title, template.link, 'Zapier app page'); // @ts-expect-error

            window.open(template.link, '_blank').focus();
          },
          className: "qa-zap-link"
        })
      }),
      customClass: "integration__panel zap-panel"
    });
  }));
};

exports.IntegrationTab = IntegrationTab;

var ZapierInstallationPanelBody = function ZapierInstallationPanelBody(_ref2) {
  var isInstalled = _ref2.isInstalled,
      onGenerateApiKey = _ref2.onGenerateApiKey,
      apiKey = _ref2.apiKey,
      onClickCopy = _ref2.onClickCopy,
      onClickRevoke = _ref2.onClickRevoke,
      region = _ref2.region;
  return (0, _preact.h)("div", {
    className: "panel-body-container installation__panel_body"
  }, (0, _preact.h)("div", {
    className: "panel-body-description"
  }, isInstalled && (0, _preact.h)("div", {
    className: "additional-text-on-installed"
  }, "To connect ", _constants.PLATFORM_BRAND_NAME, " with your Zapier account you need to add ", _constants.PLATFORM_INSIDED_NAME, " from Zapier Apps list."), (0, _preact.h)("div", {
    className: "numbered-list"
  }, (0, _preact.h)("div", {
    className: "numbered-list__number"
  }, "1"), (0, _preact.h)("div", {
    className: "numbered-list__value"
  }, "To get started with Zapier, head over to the", ' ', (0, _preact.h)("a", {
    href: "https://zapier.com/apps/insided/help",
    rel: "noreferrer",
    target: "_blank"
  }, _constants.PLATFORM_INSIDED_NAME, " app"), ' ', "in the Zapier App Directory."), (0, _preact.h)("div", {
    className: "numbered-list__number"
  }, "2"), (0, _preact.h)("div", {
    className: "numbered-list__value"
  }, "Choose an app to connect with ", _constants.PLATFORM_INSIDED_NAME, "."), (0, _preact.h)("div", {
    className: "numbered-list__number"
  }, "3"), (0, _preact.h)("div", {
    className: "numbered-list__value"
  }, "Zapier\u2019s app builder will guide you through the rest. You\u2019ll need an API key which you can generate and copy below. When asked for a region, you need to choose ", (0, _preact.h)("b", null, region), " for this instance.", isInstalled ? (0, _preact.h)(_InputGroup.default, {
    title: "API key",
    newStyle: true,
    customInput: (0, _preact.h)("div", null, (0, _preact.h)("div", {
      className: "api-key-form"
    }, (0, _preact.h)("input", {
      className: "form-control qa-zapier-api-key",
      value: apiKey,
      disabled: true
    }), (0, _preact.h)(_Button.default, {
      size: "medium",
      variant: "brand",
      title: "Copy",
      onClick: function onClick() {
        return onClickCopy();
      },
      className: "qa-copy"
    })), (0, _preact.h)(_Button.default, {
      size: "medium",
      variant: "warning",
      title: "Revoke API key",
      onClick: function onClick() {
        return onClickRevoke();
      },
      className: "integration__button_revoke qa-integration-revoke"
    }))
  }) : (0, _preact.h)(_InputGroup.default, {
    customInput: (0, _preact.h)(_Button.default, {
      size: "medium",
      variant: "brand",
      title: "Generate API key",
      onClick: function onClick() {
        return onGenerateApiKey();
      },
      className: "qa-generate-api-key"
    })
  })))));
};

var InstallationTab = function InstallationTab(_ref3) {
  var isInstalled = _ref3.isInstalled,
      _onGenerateApiKey = _ref3.onGenerateApiKey,
      apiKey = _ref3.apiKey,
      _onClickCopy = _ref3.onClickCopy,
      _onClickRevoke = _ref3.onClickRevoke,
      region = _ref3.region;
  var ZapierIntegrationPanel = {
    body: (0, _preact.h)(ZapierInstallationPanelBody, {
      isInstalled: isInstalled,
      onGenerateApiKey: function onGenerateApiKey() {
        return _onGenerateApiKey();
      },
      onClickCopy: function onClickCopy() {
        return _onClickCopy();
      },
      onClickRevoke: function onClickRevoke() {
        return _onClickRevoke();
      },
      apiKey: apiKey,
      region: region
    }),
    customClass: 'panel__body_without_header'
  };
  return (0, _preact.h)("div", {
    className: "installation__tab__wrapper"
  }, (0, _preact.h)("div", {
    className: "installation__tab installation__connect_with_zapier_tab"
  }, (0, _preact.h)(_AccordionPanel.default, {
    defaultActivePanelIndex: 0,
    panels: [ZapierIntegrationPanel]
  })), (0, _preact.h)("div", {
    className: "how-to-with-icon"
  }, (0, _preact.h)("a", {
    href: "https://community.insided.com/integrations-124/how-to-set-up-the-insided-x-zapier-integration-faq-1980",
    rel: "noreferrer",
    target: "_blank"
  }, (0, _preact.h)("span", {
    className: "how-to-link-for-block"
  }, "How to connect with Zapier"), (0, _preact.h)(_assets.default, {
    customClass: "icon-open-in-new",
    icon: "externalLink",
    width: 16,
    height: 16
  }))));
};

exports.InstallationTab = InstallationTab;